import { render, staticRenderFns } from "./VSpinner.vue?vue&type=template&id=6ea9d8a2&"
import script from "./VSpinner.vue?vue&type=script&lang=js&"
export * from "./VSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ea9d8a2')) {
      api.createRecord('6ea9d8a2', component.options)
    } else {
      api.reload('6ea9d8a2', component.options)
    }
    module.hot.accept("./VSpinner.vue?vue&type=template&id=6ea9d8a2&", function () {
      api.rerender('6ea9d8a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/volta/VSpinner.vue"
export default component.exports